import { useState, useEffect, Suspense } from 'react';
import reactLogo from './assets/react.svg'
import viteLogo from '/vite.svg'
import './App.css'
import { NavbarNested } from './components/Admin/Navigation/DesktopNav/NavbarNested.jsx';
import Header from './components/Admin/Navigation/MobileNav/Header.jsx';
import PatientHeader from './components/Patient/Navigation/MobileNav/Header.jsx';
import DealerHeader from './components/Dealer/Navigation/MobileNav/Header.jsx';
import Footer from './components/Admin/Navigation/MobileNav/Footer.jsx';
import PatientFooter from './components/Patient/Navigation/MobileNav/Footer.jsx';
import DealerFooter from './components/Dealer/Navigation/MobileNav/Footer.jsx';
import Form from './components/Patient/Registration/Form.jsx';
import { createBrowserRouter, Outlet, RouterProvider, useNavigate } from 'react-router-dom';
import { Image, useMantineTheme } from '@mantine/core';
import Home from './components/Patient/Dashboard/Home.jsx';
import authenticate from './utils/Authenticate.jsx';
import { useAppContext } from './components/context/AppContext.jsx';
import LoadingCard from './utils/LoadingCard.jsx';
import { isAdminSide } from './utils/isAdminSide.js';

 function App() {
  console.log("in app");
  const [count, setCount] = useState(0);
  const { user, setUser } = useAppContext();
  const navigate = useNavigate();

  const theme = useMantineTheme();
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 16*parseFloat(theme.breakpoints.md));
  
    useEffect(() => {
      const emToPx = (em) => em * 16; // Assuming default root font size is 16px
      const mdBreakpointInPx = emToPx(parseFloat(theme.breakpoints.md));
      const handleResize = () => {
        console.log(window.innerWidth<= mdBreakpointInPx)
        setIsMobile(window.innerWidth <= mdBreakpointInPx);
      };
  
      window.addEventListener('resize', handleResize);
  
      return () => {
        window.removeEventListener('resize', handleResize);
      };
    }, [theme.breakpoints.md]);

    useEffect( () => {
      if(user && (window.location.pathname === '/' || window.location.pathname === '/login')){
        console.log("in if");
        function directToHome(){
          if(isAdminSide(user)){
            navigate('/admin/dashboard')
          }else if(user.role === 'patient'){
            navigate('/patient/dashboard')
          }else if(user.role === 'dealer'){
            navigate('/dealer/dashboard')
          }
        }
        directToHome();
      }else{
        console.log("in else");
        if(!user) return navigate('/login') 
      }
    }, [user]);

  return (
    <>
      <div className={`${isMobile ? '!max-w-full flex flex-col' : '!max-w-full flex flex-row h-screen'}`}>
        {/* Render Desktop or Mobile Navigation */}
        {isMobile ? (
          <>
            {isAdminSide(user) ? <Header /> : (user?.role === 'dealer' ? <DealerHeader /> : <PatientHeader/>)}
          </>
        ) : (isAdminSide(user) || user?.role === 'dealer') && (
          <NavbarNested />
        )}

        {/* Main content will change based on routing */}
        <main className='w-full lg:w-5/6'>
        {!isMobile?<div className='w-full'  style={{
            width: '100%',           // Full width of the parent container
            height: '70px',          // Set the desired height for the div
            backgroundImage: 'url(/dripping.png)', // Replace with your image URL
            backgroundRepeat: 'repeat-x',   // Repeat the image horizontally
            backgroundSize: 'auto 100%',    // Scale the image to fit the height and repeat in width
            backgroundPosition: 'center',   // Align the image in the center
          }}>
        </div>:null}
        <div className='w-full p-5 pb-10 overflow-y-auto' style={{ height: 'calc(100vh - 70px)' }}>
          <Suspense fallback={<LoadingCard/>}>
            <Outlet/>
          </Suspense>
        </div>
        </main>

        {/* Render Footer only for mobile */}
        
        {
        isMobile && (isAdminSide(user)  ?
          <Footer />
          :
          user?.role === 'dealer' ? <DealerFooter /> 
          :
          user?.role === 'patient' ? <PatientFooter />:null
        )
        }
        </div>
    </>
  )
}

export default App
